<template>
  <div
    class="pa-4 overflow-y-auto position-relative max-height-calc"
    id="scroll-target"
  >
    <div v-scroll:#scroll-target="onScroll">
      <h2 class="pb-4 primaryColor">Order Management</h2>
      <section class="my-3" id="Note OM" ref="Note OM">
        <div class="mt-2 mb-6 fsize14 font-weight-bold">
          <v-card max-width="800px" outlined class="pa-4">
            <span class="teal--text">Note :</span>
            <span
              >The BASE URL, Endpoint, and Payload JSON key values are
              case-sensitive. Please use the format which we have given in the
              documentation. Orders placed above freeze quantities are split
              into multiple smaller orders.
            </span>
          </v-card>
        </div>
      </section>
      <!-- <section id="Position Convertion" ref="Position Convertion">
        <h4 class="py-3 primaryColor">Position Convertion</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span><span class="pathUrl px-2">/positionAndHoldings/positionConvertion</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in positionConvertParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.value == 'string'">
                <a @click="goToAppendix(i.link)" v-if="i.link"><span>{{i.value}}</span></a>
                <div v-else>{{i.value}}</div>
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.value" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
       {
            "pCode":"MIS",
            "productToCode":"NRML",
            "exch":"NSE",
            "qty":"2",
            "tsym":"TCS-EQ",
            "transtype":"B",
            "tokenNo":"1594",
            "type":"DAY"
        } </pre>
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in positionConvertSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">{{ i.description }}</td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in positionConvertErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">{{ i.description }}</td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock :javaCode="$store.state.javaPositionConvertion" :jsCode="$store.state.jsPositionConvertion" :curlCode="$store.state.curlPositionConvertion" />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider> -->
      <section id="Place Order" ref="Place Order">
        <h4 class="py-3 primaryColor">Place Order</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/executePlaceOrder</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in placeOrderParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
       [{ 
            "discqty":"0",
            "trading_symbol":"CRUDEOIL19APR3600CE",
            "exch":"MCX",
            "transtype":"BUY", 
            "ret":" DAY ",  
            "prctyp":"L",
            "qty":"2",
            "symbol_id":"5678943",
            "price":"3550.00",
            "trigPrice":"00.00",
            "pCode":"MIS",
            "complexty":"REGULAR",
            "orderTag":"order1",
            "deviceNumber": "sdagds345324dsfgfvasdqwr4"
        }] </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in placeOrderSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in placeOrderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaExecuteOrder"
            :jsCode="$store.state.jsExecuteOrder"
            :curlCode="$store.state.curlExecuteOrder"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Bracket Order" ref="Bracket Order">
        <h4 class="py-3 primaryColor">Bracket Order</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/executePlaceOrder</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in bracketOrderParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
        [{
              "discqty":"0",
              "trading_symbol":"CRUDEOIL19APR3600CE",
              "exch":"MCX",
              "transtype":"B", 
              "ret":"DAY",  
              "prctype":"L",
              "qty":"2",
              "price":"3550.00",
              "pCode":"MIS",
              "symbol_id":"34567",
              "target":"3545.00",
              "stopLoss":"3553.00",
              "trailing_stop_loss": "5",
              "complexty":"BO",
              "trigPrice":"00.00",
              "orderTag":"order1",
              "deviceNumber": "sdagds345324dsfgfvasdqwr4"
        }] </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in bracketOrderSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in bracketOrderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaPlaceBracketOrder"
            :jsCode="$store.state.jsPlaceBracketOrder"
            :curlCode="$store.state.curlPlaceBracketOrder"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Cover Order" ref="Cover Order">
        <h4 class="py-3 primaryColor">Cover Order</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/executePlaceOrder</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in bracketOrderParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
        [{
              "discqty":"0",
              "trading_symbol":"CRUDEOIL19APR3600CE",
              "exch":"MCX",
              "transtype":"B", 
              "ret":"DAY",  
              "prctype":"L",
              "qty":"2",
              "price":"3550.00",
              "pCode":"MIS",
              "symbol_id":"34567",
              "target":"3545.00",
              "stopLoss":"3553.00",
              "trailing_stop_loss": "5",
              "complexty":"CO",
              "trigPrice":"00.00",
              "orderTag":"order1",
              "deviceNumber": "sdagds345324dsfgfvasdqwr4"
        }] </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in coverOrderSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in coverOrderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaPlaceCoverOrder"
            :jsCode="$store.state.jsPlaceCoverOrder"
            :curlCode="$store.state.curlPlaceCoverOrder"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Square of Position" ref="Square of Position">
        <h4 class="py-3 primaryColor">Square of Position</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/positionAndHoldings/sqrOofPosition</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in positionSquareOffParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
       [{ 
            "exchSeg":"nse_cm",
            "pCode":"MIS",
            "netQty":"0",
            "tockenNo":"212",
            "symbol":"ASHOKLEY",
            "deviceNumber": "sdagds345324dsfgfvasdqwr4"
        }] </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in positionSquareOffSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in positionSquareOffErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaSquareOfPosition"
            :jsCode="$store.state.jsSquareOfPosition"
            :curlCode="$store.state.curlSquareOfPosition"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Order Book" ref="Order Book">
        <h4 class="py-3 primaryColor">Order Book</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Get </span
          ><span class="pathUrl px-2">/placeOrder/fetchOrderBook</span>
        </div>
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in orderBookSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.response == 'string'">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.response }}</span></a
                >
                <div v-else>{{ i.response }}</div>
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.response" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in orderBookErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaOrderBook"
            :jsCode="$store.state.jsOrderBook"
            :curlCode="$store.state.curlOrderBook"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Trade Book" ref="Trade Book">
        <h4 class="py-3 primaryColor">Trade Book</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Get </span
          ><span class="pathUrl px-2">/placeOrder/fetchTradeBook</span>
        </div>
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>DESCRIPTION</th>
            </tr>
            <tr v-for="(i, idex) in tradeBookSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.description }}</span></a
                >
                <div v-else>{{ i.description }}</div>
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in tradeBookErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaTradeBook"
            :jsCode="$store.state.jsTradeBook"
            :curlCode="$store.state.curlTradeBook"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Exit Bracket Order" ref="Exit Bracket Order">
        <h4 class="py-3 primaryColor">Exit Bracket Order</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/exitBracketOrder</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in exitBracketOrderParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">{{ i.value }}</td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
          {   
            "nestOrderNumber":"190817000000001",
            "symbolOrderId":"456789",
            "status":"OPEN"
          } </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>DESCRIPTION</th>
            </tr>
            <tr v-for="(i, idex) in exitBracketOrderSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in exitBracketOrderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaExitBoOrder"
            :jsCode="$store.state.jsExitBoOrder"
            :curlCode="$store.state.curlExitBoOrder"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Modify Order" ref="Modify Order">
        <h4 class="py-3 primaryColor">Modify Order</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/modifyOrder</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in modifyOrderParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
          {
              "transtype": "BUY",
               "discqty": "0",
               "exch":"MCX",
               "trading_symbol":"CRUDEOIL19APR3600CE",
               "nestOrderNumber":"190401000000031",
               "prctyp":"L",
               "price":"750.00",
               "qty":"2",
               "trading_symbol": "COPPER19JULFUT",
               "trigPrice":"00.00",
               "filledQuantity":"0",
               "deviceNumber": "sdagds345324dsfgfvasdqwr4"
          } </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>DESCRIPTION</th>
            </tr>
            <tr v-for="(i, idex) in modifyOrderSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in modifyOrderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaModifyOrder"
            :jsCode="$store.state.jsModifyOrder"
            :curlCode="$store.state.curlModifyOrder"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Market Order" ref="Market Order">
        <h4 class="py-3 primaryColor">Market Order</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/executePlaceOrder</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in placeOrderParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
           [{
                 "complexty": "REGULAR",
                 "discqty":"0",
                 "trading_symbol":"CRUDEOIL19APR3600CE",
                 "exch":"MCX",
                 "transtype":"B", 
                 "ret":"DAY",  
                 "prctyp":"L",
                 "qty":"2",
                 "price":"3550.00",
                 "pCode":"MIS",
                 "symbol_id":"34567",
                 "trigPrice":"00.00",
                 "orderTag":"order1",
                 "deviceNumber": "sdagds345324dsfgfvasdqwr4"
            }] </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>DESCRIPTION</th>
            </tr>
            <tr v-for="(i, idex) in marketOrderSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in marketOrderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaPlaceMarketOrder"
            :jsCode="$store.state.jsPlaceMarketOrder"
            :curlCode="$store.state.curlPlaceMarketOrder"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Cancel Order" ref="Cancel Order">
        <h4 class="py-3 primaryColor">Cancel Order</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/cancelOrder</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in marketOrderParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
           {   
                "exch": "MCX",
                "nestOrderNumber": "190000000000001",
                "trading_symbol": "CRUDEOILM19JULFUT",
                "deviceNumber": "sdagds345324dsfgfvasdqwr4"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
           } </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>DESCRIPTION</th>
            </tr>
            <tr v-for="(i, idex) in marketOrderSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in marketOrderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaCancelOrder"
            :jsCode="$store.state.jsCancelOrder"
            :curlCode="$store.state.curlCancelOrder"
          />
        </div>
      </section>
      <v-divider class="my-10 sec_divider"></v-divider>
      <section id="Order History" ref="Order History">
        <h4 class="py-3 primaryColor">Order History</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">/placeOrder/orderHistory</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in OrderHistoryParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">{{ i.value }}</td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
           {
                "nestOrderNumber":"190401000000031"
           } </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>DESCRIPTION</th>
            </tr>
            <tr v-for="(i, idex) in OrderHistorySuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.description }}</span></a
                >
                <div v-else>{{ i.description }}</div>
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in OrderHistoryErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaOrderHistory"
            :jsCode="$store.state.jsOrderHistory"
            :curlCode="$store.state.curlOrderHistory"
          />
        </div>
      </section>
      <section id="Basket Margin" ref="Basket Margin">
        <h4 class="py-3 primaryColor">Basket Margin</h4>
        <div class="fsize14 my-3 methodUrl">
          <span class="px-2 methodName">Post </span
          ><span class="pathUrl px-2">basket/getMargin</span>
        </div>
        <h4 class="py-3 primaryColor">Input Parameters</h4>
        <table>
          <thead>
            <tr>
              <th>KEY</th>
              <th>DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, idex) in BasketmarginParameter" :key="idex">
              <td class="pa-3">
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td class="pa-3">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.value }}</span></a
                >
                <div v-else>{{ i.value }}</div>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Example</h4>
        <pre class="cls_pre login pa-3">
          [
    {
        "exchange": "NSE",
        "tradingSymbol": "INFY-EQ",
        "price": "1475.20",
        "qty": "122",
        "product": "MIS",
        "priceType": "L",
        "token": "1594",
        "transType": "B"
    }]
 </pre
        >
        <h4 class="py-3 primaryColor">Success Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>DESCRIPTION</th>
            </tr>
            <tr v-for="(i, idex) in BasketmarginSuccessResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                <a @click="goToAppendix(i.link)" v-if="i.link"
                  ><span>{{ i.description }}</span></a
                >
                <div v-else>{{ i.description }}</div>
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="py-3 primaryColor">Error Response</h4>
        <table>
          <tbody>
            <tr>
              <th>PARAMETERS</th>
              <th>RESPONSE</th>
            </tr>
            <tr v-for="(i, idex) in BasketorderErrorResp" :key="idex">
              <td>
                <code>{{ i.key }}</code
                ><em>{{ i.type }}</em>
              </td>
              <td v-if="typeof i.description == 'string'">
                {{ i.description }}
              </td>
              <td v-else>
                <ul>
                  <li v-for="t in i.description" :key="t">{{ t }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pt-5" id="codeBlockTabs">
          <codeBlock
            :javaCode="$store.state.javaBasketMargin"
            :jsCode="$store.state.jsBasketMargin"
            :curlCode="$store.state.curlBasketMargin"
          />
        </div>
      </section>

      <div
        v-if="scrolled"
        class="pa-4 d-flex justify-end"
        style="position: sticky; right: 0; bottom: 0; z-index: 9; opacity: 1"
      >
        <v-img
          @click="$store.dispatch('scrollToTop', 'Place Order')"
          class="cursor"
          max-height="50"
          max-width="50"
          :src="require('../assets/scrollTop.png')"
        ></v-img>
      </div>
    </div>
  </div>
</template>

<script>
import codeBlock from "../views/codeBlock.vue";
import { mapGetters } from "vuex";
export default {
  data: () => ({
    //positionConvert
    positionConvertParameter: [
      {
        key: "productToCode",
        type: "String",
        value:
          "Position conversion is a process of converting your Intraday Position to Overnight and Overnight Position to Intraday. For intraday trades the Margin requirement is less compared to the Overnight Positions where the Margin requirement is high.",
      },
      {
        key: "exch",
        type: "String",
        value: "Name of the Exchange",
        link: "Exchange",
      },
      {
        key: "qty",
        type: "Int",
        value:
          "Quantity to Convert. Number of quantity converted in your Intraday Position to Overnight and Overnight Position to Intraday. For intraday trades the Margin requirement is less compared to the Overnight Positions where the Margin requirement is high",
      },
      {
        key: "tsym",
        type: "String",
        value:
          "Trading symbol of the Instrument. Trading symbol is a unique code given to all companies listed on the exchange. Selected Instrument token number will be displayed",
      },
      {
        key: "transtype",
        type: "String",
        value: "Transaction type(BUY or SELL)",
      },
      {
        key: "tokenNo",
        type: "Int",
        value:
          "Exchange token number of the scrip or instrument.Token Number is a unique code given to all companies listed on the exchange. Selected Instrument token number will be displayed",
      },
      {
        key: "type",
        type: "String",
        value: [
          "Type of position",
          "NET1 – Carry Forward Position",
          "DAY1 – Day position",
          "DAYNET - For positions which is having both Day as well as Carry Forward Position",
        ],
      },
      {
        key: "pCode",
        type: "String",
        value: "Product code (MIS or CO or CNC or BO or NRML)",
        link: "Product Type",
      },
    ],
    positionConvertSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "Result",
        type: "String",
        description: "Position Conversion Successful",
      },
    ],
    positionConvertErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve PositionConvertion",
          "Error",
          "PositionConversion Unsuccessful",
        ],
      },
    ],
    // positionSquareOff
    positionSquareOffParameter: [
      {
        key: "exchSeg",
        type: "String",
        value: "Name of the Exchange",
        link: "Exchange",
      },
      {
        key: "pCode",
        type: "String",
        value: "Product code (MIS or CO or CNC or BO or NRML)",
        link: "Product Type",
      },
      {
        key: "netQty",
        type: "Int",
        value: "Number of Quantity",
      },
      {
        key: "tockenNo",
        type: "Int",
        value:
          "Token Number is a unique code given to all companies listed on the exchange. Selected Instrument token number will be displayed",
      },
      {
        key: "symbol",
        type: "String",
        value:
          "Trading symbol of the Instrument.Token symbol is a unique code given to all companies listed on the exchange. Selected Instrument symbol will be displayed",
      },
      {
        key: "deviceNumber",
        type: "String",
        value: "Unique Device ID",
      },
    ],
    positionSquareOffSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
    ],
    positionSquareOffErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve Place Order",
          "Error Occurred : < reason>",
        ],
      },
    ],
    // placeOrder
    placeOrderParameter: [
      {
        key: "discqty",
        type: "Int",
        value:
          "Number of quantity to be disclosed to the market.A Disclosed Quantity condition allows you to disclose only a part of the order quantity to the market. This quantity, however cannot be more than the total quantity of the stocks you are purchasing. The Stock Exchange may set minimum disclosed quantity criteria from time to time.",
      },
      {
        key: "trading_symbol",
        type: "String",
        value:
          "Trading symbol is a unique code given to all companies listed on the exchange. Selected Instrument symbol will be displayed",
      },
      {
        key: "exch",
        type: "String",
        value: "Exchange(NSE or BSE or NFO or MCX)",
        link: "Exchange",
      },
      {
        key: "transtype",
        type: "String",
        value: "Transaction Type (BUY or SELL)",
        link: "Transaction Type",
      },
      {
        key: "ret",
        type: "String",
        value:
          "These orders state the system to keep the orders pending until the market price reaches the specified limit order price. The various retention orders are: Day or End of Session Order: This is the most commonly used retention type",
      },
      {
        key: "prctyp",
        type: "String",
        value: "Price type(L or MKT or SL or SL-M)",
        link: "Price Type",
      },
      {
        key: "qty",
        type: "Int",
        value:
          "Number of quantity to transact.The amount of a PRODUCT (or FACTOR OF PRODUCTION) that is bought or sold. In most markets the quantity traded will depend upon the interaction of DEMAND and SUPPLY in determining the product's EQUILIBRIUM MARKET PRICE.",
      },
      {
        key: "symbol_id",
        type: "String",
        value: "Trading symbol Token",
      },
      {
        key: "price",
        type: "Int",
        value: "Average Price of the Instrument will be displayed.",
      },
      {
        key: "trigPrice",
        type: "Int",
        value:
          "Price at which order will be triggered applicable for Order Type as Stop Loss Limit or Stop Loss Market.",
      },
      {
        key: "pCode",
        type: "String",
        value: "Product code (MIS or CO or CNC or BO or NRML)",
        link: "Product Type",
      },
      {
        key: "complexty",
        type: "String",
        value:
          "Order complexity is a term for special trade orders that involve one or more legs and intend to minimize losses and ensure profits. Such orders include bracket orders or OCO (One Cancels the Other), cover orders and After Market Orders.",
      },
      {
        key: "orderTag",
        type: "String",
        value:
          "Add your remarks or description of the order. It will display in the order book response in the 'Remark' key.",
      },
      {
        key: "deviceNumber",
        type: "String",
        value: "Unique Device ID",
      },
    ],
    placeOrderSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
    ],
    placeOrderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve Place Order",
          "Error Occurred : < reason>",
        ],
      },
    ],
    // bracket Order
    bracketOrderParameter: [
      {
        key: "discqty",
        type: "Int",
        value:
          "A Disclosed Quantity condition allows you to disclose only a part of the order quantity to the market. This quantity, however cannot be more than the total quantity of the stocks you are purchasing. The Stock Exchange may set minimum disclosed quantity criteria from time to time.",
      },
      {
        key: "trading_symbol",
        type: "String",
        value:
          "Trading Symbol of the Instrument.Trading Symbol is a unique code given to all companies listed on the exchange. Selected Instrument Trading Symbol will be displayed",
      },
      {
        key: "exch",
        type: "String",
        value: "Exchange (NSE or BSE or NFO or MCX)",
        link: "Exchange",
      },
      {
        key: "transtype",
        type: "String",
        value: "Transaction Type (BUY or SELL)",
        link: "Transaction Type",
      },
      {
        key: "ret",
        type: "String",
        value:
          "These orders state the system to keep the orders pending until the market price reaches the specified limit order price. The various retention orders are: Day or End of Session Order: This is the most commonly used retention type",
      },
      {
        key: "prctype",
        type: "String",
        value: "Price type(L or MKT or SL or SL-M)",
        link: "Price Type",
      },
      {
        key: "qty",
        type: "Int",
        value:
          "Number of quantity to transact.The amount of a PRODUCT (or FACTOR OF PRODUCTION) that is bought or sold. In most markets the quantity traded will depend upon the interaction of DEMAND and SUPPLY in determining the product's EQUILIBRIUM MARKET PRICE.",
      },
      {
        key: "price",
        type: "Int",
        value: "Price at which main leg of bracket order will be placed",
      },
      {
        key: "pCode",
        type: "Int",
        value: "Product code (MIS or CO or CNC or BO or NRML)",
        link: "Product Type",
      },
      {
        key: "symbol_id",
        type: "String",
        value: "Trading symbol Token",
      },
      {
        key: "target",
        type: "String",
        value:
          "A target price is an estimate of the future price of a stock. Target prices are based on earnings forecasts and assumed valuation multiples. Target prices can be used to evaluate stocks and may be even more useful than an equity analyst's rating.",
      },
      {
        key: "stopLoss",
        type: "String",
        value:
          "A stop-loss order is an order placed with a broker to buy or sell a specific stock once the stock reaches a certain price. A stop-loss is designed to limit an investor's loss on a security position. For example, setting a stop-loss order for 10% below the price at which you bought the stock will limit your loss to 10%.",
      },
      {
        key: "trailing_stop_loss",
        type: "String",
        value:
          "A trailing stop loss order adjusts the stop price at a fixed percent or number of points below or above the market price of a stock",
      },
      {
        key: "complexty",
        type: "String",
        value:
          "Order complexity is a term for special trade orders that involve one or more legs and intend to minimize losses and ensure profits. Such orders include bracket orders or OCO (One Cancels the Other), cover orders and After Market Orders.",
      },
      {
        key: "trigPrice",
        type: "Int",
        value:
          "Price at which order will be triggered applicable for Order Type as Stop Loss Limit or Stop Loss Market.",
      },
      {
        key: "orderTag",
        type: "String",
        value:
          "Add your remarks or description of the order. It will display in the order book response in the 'Remark' key.",
      },
      {
        key: "deviceNumber",
        type: "String",
        value: "Unique Device ID",
      },
    ],
    bracketOrderSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
    ],
    bracketOrderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve BO PlaceOrder",
          "Error Occurred : < reason>",
          "Trailing Tick should be multiple of tick size : [tickValue in rupees]",
        ],
      },
    ],
    coverOrderSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
    ],
    coverOrderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve BO PlaceOrder",
          "Error Occurred : < reason>",
          "Trailing Tick should be multiple of tick size : [tickValue in rupees]",
        ],
      },
    ],
    // order Book
    orderBookSuccessResp: [
      {
        key: "stat",
        type: "String",
        response: "Ok",
      },
      {
        key: "Exseg",
        type: "String",
        response: "Exchange Segment Name",
        link: "Exchange",
      },
      {
        key: "Trsym",
        type: "String",
        response:
          "A trading symbol is an arrangement of characters usually letters representing publicly-traded securities on an exchange. When a company issues securities to the public marketplace, it selects an available symbol for its shares, often related to the company name. Investors and traders use the symbol to place trade orders..",
      },
      {
        key: "Nstordno",
        type: "Int",
        response:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "Prc",
        type: "Int",
        response: "Average Price of the Instrument will be displayed.",
      },
      {
        key: "Qty",
        type: "Int",
        response:
          "Quantity ordered. The total quantity of shares or contracts traded for a specified instrument.",
      },
      {
        key: "Dscqty",
        type: "Int",
        response:
          "A Disclosed Quantity condition allows you to disclose only a part of the order quantity to the market. This quantity, however cannot be more than the total quantity of the stocks you are purchasing. The Stock Exchange may set minimum disclosed quantity criteria from time to time.",
      },
      {
        key: "Trgprc",
        type: "Int",
        response:
          "Price at which order will be triggered applicable for Order Type as Stop Loss Limit or Stop Loss Market.",
      },
      {
        key: "Validity",
        type: "String",
        response:
          "Order validity is the period for which a placed order is valid. ",
      },
      {
        key: "Scripname",
        type: "String",
        response: "Placed Order scrip name will be displayed",
      },
      {
        key: "Sym",
        type: "String",
        response: "Scrip token",
      },
      {
        key: "Status",
        type: "String",
        response:
          "Current status of the order. Most common values or COMPLETE, REJECTED, CANCELLED, and OPEN. There may be other values as well.",
      },
      {
        key: "Fillshares",
        type: "String",
        response: "The Number of shares got filled",
      },
      {
        key: "ExpDate",
        type: "Int",
        response:
          "Stock's Expiry date will be displayed.An expiry date in trading is the point at which a position automatically closes. In other words, a trader will have to decide what they want to do with their open position before the expiry date.",
      },
      {
        key: "Ordvaldate",
        type: "Int",
        response:
          "Order validity is the period for which a placed order is valid",
      },
      {
        key: "Pcode",
        type: "String",
        response: "Product code (MIS or CO or CNC or BO or NRML)",
        link: "Product Type",
      },
      {
        key: "Avgprc",
        type: "Int",
        response:
          "Average price at which the net position quantity was acquired",
      },
      {
        key: "Unfilledsize",
        type: "Int",
        response: "The Number of shares got unfilled",
      },
      {
        key: "ExchOrdID",
        type: "Int",
        response: "The Unique order ID which generate from the exchange",
      },
      {
        key: "RejReason",
        type: "String",
        response: "Rejection Reason for the order will be displayed",
      },
      {
        key: "ExchConfrmtime",
        type: "Float",
        response: "Exchange Confirmation Time",
      },
      {
        key: "Mktpro",
        type: "String",
        response:
          "A market-with-protection order cancels an order to buy or sell stock or other assets and re-submits it as a limit order. A broker might submit a market-with-protection order if the price of the stock has moved unexpectedly and dramatically since the market order was placed.",
      },
      {
        key: "Cancelqty",
        type: "Int",
        response:
          "A cancelled order is a previously submitted order to buy or sell a security that gets cancelled before it executes on an exchange. Investors may cancel standing orders, such as a limit or stop order, for any reason so long as the order has not been filled yet.",
      },
      {
        key: "Trantype",
        type: "String",
        response: "Transaction type(BUY or SELL)",
        link: "Transaction Type",
      },
      {
        key: "Prctype",
        type: "String",
        response: "Price type(L or MKT or SL or SL-M)",
        link: "Price Type",
      },
      {
        key: "Exchange",
        type: "String",
        response: "Exchange Name",
        link: "Exchange",
      },
      {
        key: "ticksize",
        type: "Float",
        response:
          "Ticker Size Of The Scrip (in paisa).Tick size is the minimum price change between different bid and offer prices of an asset traded on an exchange platform",
      },
      {
        key: "decprec",
        type: "Float",
        response: "Decimal Precision",
      },
      {
        key: "multiplier",
        type: "Int",
        response: "Multiplier Of Scrip",
      },
      {
        key: "bqty",
        type: "Int",
        response:
          "A board lot quantity is a standardized number of shares defined by a stock exchange as a trading unit.A board lot quantity is what the exchange determines to be a round lot.",
      },
      {
        key: "mpro",
        type: "String",
        response: "Market Protection Flag",
      },
      {
        key: "token",
        type: "String",
        response: "Token Of The Scrip",
      },
      {
        key: "noMktPro",
        type: "String",
        response: "No Market Protection Flag",
      },
      {
        key: "defmktproval",
        type: "Int",
        response: "Default Market Protection Value",
      },
      {
        key: "RequestID",
        type: "String",
        response: "Nest Request ID",
      },
      {
        key: "SyomOrderId",
        type: "String",
        response: "Syom Order ID",
      },
      {
        key: "RefLmtPrice",
        type: "Int",
        response: "Reference Limit Price For CO Order",
      },
      {
        key: "COPercentage",
        type: "Int",
        response: "Cover Order Percentage will be displayed",
      },
      {
        key: "InstName",
        type: "String",
        response: "Placed Ordered Instrument name will be displayed",
      },
      {
        key: "ExpSsbDate",
        type: "Int",
        response: "Expiry Date Of Scrip In ssboe Format",
      },
      {
        key: "discQtyPerc",
        type: "Int",
        response: "Disclose Quantity Percentage For Exchanges",
      },
      {
        key: "Minqty",
        type: "Int",
        response:
          "Minimum Order Quantity (MOQ) simply means the minimum amount your retailer has to spend per order to be able to stock your products at their store",
      },
      {
        key: "BrokerClient",
        type: "String",
        response: "Specifies The Broker-Client Relationship",
      },
      {
        key: "user",
        type: "String",
        response: "Logged in User Id will be displayed",
      },
      {
        key: "accountId",
        type: "String",
        response: "Logged in Account Id will be displayed",
      },
      {
        key: "PriceNumerator",
        type: "Int",
        response:
          "The price numerator in the ratio is the share price, which is the price a single share of a company's stock sells for at a specific time. A company's share price is easily determined simply by looking at a price chart for the company's stock",
      },
      {
        key: "GeneralNumerator",
        type: "Int",
        response: "General Numerator",
      },
      {
        key: "PriceDenomenator",
        type: "Int",
        response:
          "A company's share price is easily determined simply by looking at a price chart for the company's stock. The denominator is the per-share metric used for the specific price multiple calculation. The metric measures some aspect of a company's performance.",
      },
      {
        key: "GeneralDenomenator",
        type: "Int",
        response: "General Denominator",
      },
      {
        key: "series",
        type: "String",
        response: "Scrip Group Or Series",
      },
      {
        key: "orderentrytime",
        type: "time",
        response: "Order Entry Time",
      },
      {
        key: "ordergenerationtype",
        type: "String",
        response: "Order Generation Type",
      },
      {
        key: "sipindicator",
        type: "String",
        response: "Sip Indicatior",
      },
      {
        key: "ordersource",
        type: "String",
        response: "Order Source display the order placed by whom",
      },
      {
        key: "remarks",
        type: "String",
        response: "Remarks for the order",
      },
      {
        key: "marketprotectionpercentage",
        type: "Int",
        response: "Market Protection Percentage",
      },
      {
        key: "reporttype",
        type: "String",
        response: "Report Type (Success or Failure)",
      },
      {
        key: "iSinceBOE",
        type: "time",
        response: "Seconds Since boe",
      },
      {
        key: "usecs",
        type: "time",
        response: "u Seconds",
      },
      {
        key: "modifiedBy",
        type: "String",
        response:
          "If user modified the order Modified By user will be displayed.",
      },
      {
        key: "optionType",
        type: "String",
        response:
          "There are four basic option types: buying a call option(BC), selling a call option(SC), buying a put option(BP), and selling a put option(SP).A call gives the buyer the right, to buy the underlying asset at the specified strike price. A put gives the buyer the right, to sell an asset at a specified strike price as in the contract.",
      },
      {
        key: "strikePrice",
        type: "Int",
        response:
          "A strike price is a set price at which a derivative contract can be bought or sold when it is exercised. For call options, the strike price is where the security can be bought by the option holder; for put options, the strike price is the price at which the security can be sold.",
      },
      {
        key: "Usercomments",
        type: "String",
        response: "Remarks Sent In Place Order API",
      },
      {
        key: "AlgoID",
        type: "String",
        response: "Exchange Algo ID",
      },
      {
        key: "AlgoCategory",
        type: "String",
        response: "Exchange Algo Category",
      },
      {
        key: "panNo",
        type: "Int",
        response: "User registered Pan Number",
      },
      {
        key: "OrderedTime",
        type: "time",
        response: "Ordered Date And Time ( DD/MM/YYYY HH:MM:SS)",
      },
      {
        key: "exchangeuserinfo",
        type: "String",
        response: "Exchange User Info",
      },
      {
        key: "Remark",
        type: "String",
        response: "Order description/Tag",
      },
    ],
    orderBookErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve Order Book",
          "No Data",
        ],
      },
    ],
    // trade Book
    tradeBookSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "Exchange",
        type: "String",
        description: "Exchange Name",
        link: "Exchange",
      },
      {
        key: "Tsym",
        type: "String",
        description:
          "Trading Symbol of the Instrument.Trading Symbol is a unique code given to all companies listed on the exchange. Selected Instrument Trading Symbol will be displayed",
      },
      {
        key: "Filledqty",
        type: "Int",
        description: "The Number of shares got filled",
      },
      {
        key: "Average price",
        type: "Int",
        description:
          "Average Price Of The Order Placed.Average price is the mean price of an asset or security observed over some period of time. It is calculated by finding the simple arithmetic average of closing prices over a specified time period. When adjusted by trading volume, the volume-weighted average price (VWAP) can be derived on an intraday basis.",
      },
      {
        key: "Pcode",
        type: "String",
        description: "Product code (MIS or CO or CNC or BO or NRML)",
        link: "Product Type",
      },
      {
        key: "Nstordno",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "Trantype",
        type: "String",
        description: "Transaction type(BUY or SELL)",
        link: "Transaction Type",
      },
      {
        key: "FillId",
        type: "String",
        description: "Fill Id",
      },
      {
        key: "Symbol",
        type: "String",
        description:
          "A stock symbol is an arrangement of characters—usually letters—representing publicly-traded securities on an exchange",
      },
      {
        key: "Unfillqty",
        type: "String",
        description: "The Number of shares got unfilled",
      },
      {
        key: "Exchseg",
        type: "String",
        description: "Exchange Segment Name",
        link: "Exchange",
      },
      {
        key: "Custofrm",
        type: "String",
        description:
          "A firm order in trading is one that is in effect until it has been explicitly canceled, or has met some preconditions that invalidate it. A firm order may also refer to a buy or sell order placed on behalf of a financial institution for their own accounts.",
      },
      {
        key: "Prctype",
        type: "String",
        description: "Price type(L or MKT or SL or SL-M)",
        link: "Price Type",
      },
      {
        key: "Ordduration",
        type: "Int",
        description:
          "A day order is a stipulation placed on an order to a broker to execute a trade at a specific price that expires at the end of the trading day if it is not completed. A day order can be a limit order to buy or sell a security, but its duration is limited to the remainder of that trading day.",
      },
      {
        key: "NOReqID",
        type: "Int",
        description: "The unique Nest Order Request Id",
      },
      {
        key: "FillLeg",
        type: "String",
        description:
          "A leg refers to one part of a multi-step or multi-part trade, such as in a spread strategy. A trader will leg-into a strategy to hedge a position, benefit from arbitrage, or profit from a spread.",
      },
      {
        key: "Filldate",
        type: "Int",
        description: "Fill Date",
      },
      {
        key: "Filltime",
        type: "Time",
        description: "Fill Time",
      },
      {
        key: "Qty",
        type: "Int",
        description:
          "Volume of trade is the total quantity of shares or contracts traded for a specified security. It can be measured on any type of security traded during a trading day. Volume of trade or trade volume is measured on stocks, bonds, options contracts, futures contracts, and all types of commodities.",
      },
      {
        key: "ExchordID",
        type: "String",
        description:
          "Exchange ID means an ID that is provided to the Exchange in order to identify a Seller that will trade under the Exchange.",
      },
      {
        key: "Time",
        type: "Time",
        description: "Time",
      },
      {
        key: "Exchtime",
        type: "Time",
        description:
          "Exchange time, this will be set based on the exchange feeds.Exchange time defines market opening and closing times",
      },
      {
        key: "posflag",
        type: "String",
        description: "Position Flag (true/false)",
      },
      {
        key: "Minqty",
        type: "Int",
        description:
          "Minimum order quantity is the fewest number of units a business is willing to sell to a single customer at once.",
      },
      {
        key: "BrokerClient",
        type: "String",
        description:
          "A Unique Relationship. In most states the stockbroker-client relationship is unique and is designed to benefit and protect the investor. Many states impose a fiduciary duty upon financial advisors who make recommendations and investments on behalf of clients.",
      },
      {
        key: "accountId",
        type: "String",
        description: "Account Id",
      },
      {
        key: "ReportType",
        type: "String",
        description: "Report Type (Success or Failure)",
      },
      {
        key: "PriceNumerator",
        description:
          "The numerator in the ratio is the share price, which is the price a single share of a company's stock sells for at a specific time. A company's share price is easily determined simply by looking at a price chart for the company's stock",
      },
      {
        key: "GeneralNumerator",
        type: "Int",
        description: "General Numerator",
      },
      {
        key: "user",
        type: "String",
        description: "Users Logged in ID will be displayed",
      },
      {
        key: "PriceDenomenator",
        type: "Int",
        description:
          "A company's share price is easily determined simply by looking at a price chart for the company's stock. The denominator is the per-share metric used for the specific price multiple calculation. The metric measures some aspect of a company's performance.",
      },
      {
        key: "GeneralDenomenator",
        type: "Int",
        description: "General Denomenator",
      },
      {
        key: "bqty",
        type: "Int",
        description:
          "Board Lot Quantity is a standardized number of shares defined by a stock exchange as a trading unit. In most cases, this means 100 shares. A board lot is what the exchange determines to be a round lot. The purpose of a board lot is to minimize trading odd lots and to facilitate easier trading.",
      },
      {
        key: "companyname",
        type: "String",
        description: "Required Company name will be displayed",
      },
      {
        key: "series",
        type: "String",
        description: "Series Or Group",
      },
      {
        key: "ordergenerationtype",
        type: "String",
        description: "Order Generation Type",
      },
      {
        key: "remarks",
        type: "String",
        description: "Remarks for the instrument",
      },
      {
        key: "symbolname",
        type: "String",
        description:
          "Symbol name for the scrip or instrument will be displayed",
      },
      {
        key: "iSinceBOE",
        type: "Time",
        description: "Seconds Since boe",
      },
      {
        key: "usecs",
        type: "Time",
        description: "u Seconds",
      },
      {
        key: "Expiry",
        type: "Int",
        description:
          "Stock's Expiry date will be displayed.An expiry date in trading is the point at which a position automatically closes. In other words, a trader will have to decide what they want to do with their open position before the expiry date.",
      },
      {
        key: "expdate",
        type: "Int",
        description: "Expiry Date ssboe Format",
      },
      {
        key: "strikeprice",
        type: "Int",
        description:
          "A strike price is a set price at which a derivative contract can be bought or sold when it is exercised. For call options, the strike price is where the security can be bought by the option holder; for put options, the strike price is the price at which the security can be sol",
      },
      {
        key: "optiontype",
        type: "String",
        description:
          "There are four basic option types: buying a call option(BC), selling a call option(SC), buying a put option(BP), and selling a put option(SP).A call gives the buyer the right, to buy the underlying asset at the specified strike price. A put gives the buyer the right, to sell an asset at a specified strike price as in the contract.",
      },
      {
        key: "AlgoID",
        type: "String",
        description: "Exchange Algo ID",
      },
      {
        key: "AlgoCategory",
        type: "String",
        description: "Exchange Algo Category",
      },
      {
        key: "panNo",
        type: "Int",
        description: "User's Registered Pan Number",
      },
    ],
    tradeBookErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve TradeBook",
          "No Data",
        ],
      },
    ],
    // Exit Bracket Order
    exitBracketOrderParameter: [
      {
        key: "nestOrderNumber",
        type: "Int",
        value:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "symbolOrderId",
        type: "String",
        value: "Symbol Order Id ( Leg order Indicator )",
      },
      {
        key: "status",
        type: "String",
        value: "Status of the order from Order Book",
      },
    ],
    exitBracketOrderSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
    ],
    exitBracketOrderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: ["Session Expired", "Error Occurred", "Error in Handler"],
      },
    ],
    // modify Order
    modifyOrderParameter: [
      {
        key: "transtype",
        type: "String",
        value: "Transcation Type(BUY or SELL)",
        link: "Transaction Type",
      },

      {
        key: "discqty",
        type: "Int",
        value:
          "Number of quantity to be disclosed to the market.A Disclosed Quantity condition allows you to disclose only a part of the order quantity to the market. This quantity, however cannot be more than the total quantity of the stocks you are purchasing. The Stock Exchange may set minimum disclosed quantity criteria from time to time.",
      },
      {
        key: "exch",
        type: "String",
        value: "Exchange Name",
        link: "Exchange",
      },
      {
        key: "trading_symbol",
        type: "String",
        value:
          "Trading Symbol of the Instrument.A Trading symbol is an arrangement of characters—usually letters—representing publicly-traded securities on an exchange. When a company issues securities to the public marketplace, it selects an available symbol for its shares, often related to the company name. Investors and traders use the symbol to place trade orders.",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        value:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "prctyp",
        type: "String",
        value: "Price type(L or MKT or SL or SL-M)",
        link: "Price Type",
      },
      {
        key: "price",
        type: "Int",
        value: "Price at which order will be placed",
      },
      {
        key: "qty",
        type: "Int",
        value:
          "If the user modified quantity, no.of modified quantity will be displayed",
      },
      {
        key: "trigPrice",
        type: "Int",
        value:
          "Price at which order will be triggered applicable for Order Type as Stop Loss Limit or Stop Loss Market.",
      },
      {
        key: "filledQuantity",
        type: "Int",
        value: "Quantity that's been filled",
      },
      {
        key: "pCode",
        type: "Int",
        value: "Product code (MIS or CO or CNC or BO or NRML)",
        link: "Product Type",
      },
      {
        key: "deviceNumber",
        type: "String",
        value: "Unique Device ID",
      },
    ],
    modifyOrderSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "Result",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
    ],
    modifyOrderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve ModifyOrder",
          "Error Occurred : < reason>",
          "You have to enter Date dd-MM-yyyy for GTD Orders.",
          "Invalid Good Till Date: Cannot be in the Past.",
          "Invalid Order Status",
          "MARKET PROTECTION is not allowed for Limit Order Type",
          "No Data",
        ],
      },
    ],
    // market Order
    marketOrderParameter: [
      {
        key: "Exchange",
        type: "String",
        value: "Exchange",
        link: "Exchange",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        value:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "trading_symbol",
        type: "String",
        value:
          "Trading Symbol of the Instrument.A Trading symbol is an arrangement of characters—usually letters—representing publicly-traded securities on an exchange. When a company issues securities to the public marketplace, it selects an available symbol for its shares, often related to the company name. Investors and traders use the symbol to place trade orders.",
      },
      {
        key: "deviceNumber",
        type: "String",
        value: "Unique Device ID",
      },
    ],
    marketOrderSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number will be created while placing the order",
      },
    ],
    marketOrderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Error Occurred : < reason>",
          "Trailing Tick should be multiple of tick size : [tickValue in rupees]",
        ],
      },
    ],
    // cancel Order
    CancelOrderParameter: [
      {
        key: "Exchange",
        type: "String",
        value: "Exchange",
        link: "Exchange",
      },
      {
        key: "nestOrderNumber",
        type: "Int",
        value:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "trading_symbol",
        type: "String",
        value: "Symbol",
      },
    ],
    CancelOrderSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "Result",
        type: "Int",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
    ],
    CancelOrderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve CancelOrder",
          "Error Occurred : < reason>",
          "Invalid Order Status",
          "No Data",
        ],
      },
    ],
    // Order History
    OrderHistoryParameter: [
      {
        key: "nestOrderNumber",
        type: "Int",
        value:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
    ],
    OrderHistorySuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "Trsym",
        type: "String",
        description:
          "Trading Symbol of the Instrument.A Trading symbol is an arrangement of characters—usually letters—representing publicly-traded securities on an exchange. When a company issues securities to the public marketplace, it selects an available symbol for its shares, often related to the company name. Investors and traders use the symbol to place trade orders.",
      },
      {
        key: "Prc",
        type: "Int",
        description: "Average Price of the Instrument will be displayed",
      },
      {
        key: "Qty",
        type: "Int",
        description:
          "Number of quantity to transact.The amount of a PRODUCT (or FACTOR OF PRODUCTION) that is bought or sold. In most markets the quantity traded will depend upon the interaction of DEMAND and SUPPLY in determining the product's EQUILIBRIUM MARKET PRICE.",
      },
      {
        key: "Status",
        type: "String",
        description:
          "Current status of the order. Most common values or COMPLETE, REJECTED, CANCELLED, and OPEN. There may be other values as well.",
      },
      {
        key: "Action",
        type: "String",
        description: "Transaction Type",
      },
      {
        key: "Ordtype",
        type: "String",
        description:
          "An order type in the stock market is a method you choose to execute the buy/sell order by your broker. The common order types include a market order and a limit order.",
      },
      {
        key: "PriceNumerator",
        type: "String",
        description:
          "The numerator in the ratio is the share price, which is the price a single share of a company's stock sells for at a specific time. A company's share price is easily determined simply by looking at a price chart for the company's stock",
      },
      {
        key: "GeneralNumerator",
        type: "String",
        description: "General Numerator",
      },
      {
        key: "PriceDenomenator",
        type: "String",
        description:
          "A company's share price is easily determined simply by looking at a price chart for the company's stock. The denominator is the per-share metric used for the specific price multiple calculation. The metric measures some aspect of a company's performance.",
      },
      {
        key: "GeneralDenomenator",
        type: "String",
        description: "General Denominator",
      },
      {
        key: "bqty",
        type: "String",
        description:
          "A board lot is a standardized number of shares defined by a stock exchange as a trading unit. In most cases, this means 100 shares. A board lot is what the exchange determines to be a round lot. The purpose of a board lot is to minimize trading odd lots and to facilitate easier trading.",
      },
      {
        key: "exchange",
        type: "String",
        description: "Name of the Exchange",
        link: "Exchange",
      },
      {
        key: "nestordernumber",
        type: "String",
        description:
          "NNest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "nestreqid",
        type: "String",
        description: "Nest Request Id",
      },
      {
        key: "symbolname",
        type: "String",
        description: "Symbol Name",
      },
      {
        key: "averageprice",
        type: "Int",
        description:
          "Average price at which the net position quantity was acquired",
      },
      {
        key: "triggerprice",
        type: "Int",
        description:
          "The price at which your buy or sell order becomes active for execution on the exchange is known as the trigger price",
      },
      {
        key: "disclosedqty",
        type: "String",
        description:
          "A Disclosed Quantity condition allows you to disclose only a part of the order quantity to the market. This quantity, however cannot be more than the total quantity of the stocks you are purchasing. The Stock Exchange may set minimum disclosed quantity criteria from time to time.",
      },
      {
        key: "exchangeorderid",
        type: "String",
        description: "Exchange Order Id",
      },
      {
        key: "rejectionreason",
        type: "String",
        description: "Rejected Reason of an order",
      },
      {
        key: "duration",
        type: "String",
        description: "Order Duration of the order",
      },
      {
        key: "productcode",
        type: "String",
        description: "Product Code",
        link: "Product Code",
      },
      {
        key: "reporttype",
        type: "String",
        description: "Report Type (Success or Failure)",
      },
      {
        key: "customerfirm",
        type: "String",
        description: "Customer Firm",
      },
      {
        key: "exchangetimestamp",
        type: "Int",
        description:
          "Exchange Time Stamp.Part of the order-routing process in which the time of day is stamped on an order.",
      },
      {
        key: "ordersource",
        type: "String",
        description: "Order Source display the order placed by whom",
      },
      {
        key: "filldateandtime",
        type: "String",
        description: "The Date and time of shares fill",
      },
      {
        key: "ordergenerationtype",
        type: "String",
        description: "Order Generation Type",
      },
      {
        key: "scripname",
        type: "String",
        description: "Selected Scrip Name will be displayed",
      },
      {
        key: "legorderindicator",
        type: "String",
        description: "A leg is a single position taken in trading",
      },
      {
        key: "filledShares",
        type: "String",
        description:
          "A fill is the result of an order execution to buy or sell securities in the market.",
      },
    ],
    OrderHistoryErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve OrderHistory",
          "No Data",
        ],
      },
    ],

    // Basket Margin
    BasketmarginParameter: [
      {
        key: "Exchange",
        type: "String",
        value: "Exchange(NSE or BSE or NFO or MCX)",
        link: "Exchange",
      },

      {
        key: "tradingSymbol",
        type: "Int",
        value: "Trading symbol of the instrument",
      },
      {
        key: "price",
        type: "Int",
        value: "Price at which order to be placed",
      },
      {
        key: "qty",
        type: "Int",
        value:
          "Number of quantity to transact.The amount of a PRODUCT (or FACTOR OF PRODUCTION) that is bought or sold. In most markets the quantity traded will depend upon the interaction of DEMAND and SUPPLY in determining the product's EQUILIBRIUM MARKET PRICE.",
      },
      {
        key: "product",
        type: "String",
        link: "Product Type",
        value: `Product code (MIS or CO or CNC or BO or NRML)`,
      },
      {
        key: "priceType",
        type: "String",
        value: "(L or MKT or SL or SL-M)",
      },
      {
        key: "Token",
        type: "Int",
        value:
          "The price at which your buy or sell order becomes active for execution on the exchange is known as the trigger price",
      },
      {
        key: "transType",
        type: "String",
        value: "Transaction Type (BUY or SELL)",
        link: "Transaction Type",
      },
    ],
    BasketmarginSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "marginUsed",
        type: "Int",
        description: "The money needed to complete all orders in the basket.",
      },
      {
        key: "marginUsedTrade",
        type: "Int",
        description:
          "The funds reserved in your trading account once the order is executed.",
      },
    ],
    BasketorderErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve Basketorder",
          "No Data",
        ],
      },
    ],

    // holdings
    holdingsSuccessResp: [
      {
        key: "stat",
        type: "String",
        description: "Ok",
      },
      {
        key: "Trsym",
        type: "String",
        description: "Trading Symbol",
      },
      {
        key: "Prc",
        type: "Int",
        description: "Price",
      },
      {
        key: "Qty",
        type: "Int",
        description: "Quantity",
      },
      {
        key: "Status",
        type: "String",
        description: "Status Of The Order",
      },
      {
        key: "Action",
        type: "String",
        description: "Transaction Type",
      },
      {
        key: "Ordtype",
        type: "String",
        description: "Order Type",
      },
      {
        key: "PriceNumerator",
        type: "String",
        description: "Price Numerator",
      },
      {
        key: "GeneralNumerator",
        type: "String",
        description: "General Numerator",
      },
      {
        key: "PriceDenomenator",
        type: "String",
        description: "Price Denominator",
      },
      {
        key: "GeneralDenomenator",
        type: "String",
        description: "General Denominator",
      },
      {
        key: "bqty",
        type: "String",
        description: "Board Lot Quantity",
      },
      {
        key: "exchange",
        type: "String",
        description: "Exchange",
        link: "Exchange",
      },
      {
        key: "nestordernumber",
        type: "String",
        description:
          "Nest Order Number is defined as Unique number it can be generated while placing the order",
      },
      {
        key: "nestreqid",
        type: "String",
        description: "Nest Request Id",
      },
      {
        key: "symbolname",
        type: "String",
        description: "Symbol Name",
      },
      {
        key: "averageprice",
        type: "Int",
        description: "Average Price",
      },
      {
        key: "triggerprice",
        type: "Int",
        description: "Trigger Price",
      },
      {
        key: "disclosedqty",
        type: "String",
        description: "Disclosed Quantity",
      },
      {
        key: "exchangeorderid",
        type: "String",
        description: "Exchange Order Id",
      },
      {
        key: "rejectionreason",
        type: "String",
        description: "Rejection Reason",
      },
      {
        key: "duration",
        type: "String",
        description: "Order Duration",
      },
      {
        key: "productcode",
        type: "String",
        description: "Product Code",
      },
      {
        key: "reporttype",
        type: "String",
        description: "Report Type (Success or Failure)",
      },
      {
        key: "customerfirm",
        type: "String",
        description: "Customer Firm",
      },
      {
        key: "exchangetimestamp",
        type: "Int",
        description: "Exchange Time Stamp",
      },
      {
        key: "ordersource",
        type: "String",
        description: "Order Source display the order placed by whom",
      },
      {
        key: "filldateandtime",
        type: "String",
        description: "The Date and time of shares fill",
      },
      {
        key: "ordergenerationtype",
        type: "String",
        description: "Order Generation Type",
      },
      {
        key: "scripname",
        type: "String",
        description: "Scrip Name",
      },
      {
        key: "legorderindicator",
        type: "String",
        description: "Leg Order Indicator",
      },
      {
        key: "filledShares",
        type: "String",
        description: "Filled Shares",
      },
    ],
    holdingsErrorResp: [
      { key: "stat", type: "String", description: "Not_Ok" },
      {
        key: "emsg",
        type: "String",
        description: [
          "Session Expired",
          "Not able to Retrieve Holding",
          "No Data",
        ],
      },
    ],
  }),
  components: {
    codeBlock,
  },
  computed: {
    ...mapGetters({
      activeTab: "getActiveTab",
      scrolled: "getScrolled",
    }),
  },
  watch: {
    activeTab(val) {
      this.gotoSection(val);
    },
  },
  methods: {
    gotoSection(refName) {
      var element = this.$refs[refName];
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    async goToAppendix(link) {
      this.$store.commit("setActiveTab", await link);
      this.$router.push("appendix");
    },
    onScroll(e) {
      var offsetTop = e.target.scrollTop;
      offsetTop > 500
        ? this.$store.commit("setScrolled", true)
        : this.$store.commit("setScrolled", false);
    },
  },
  mounted() {
    this.gotoSection(this.$store.getters.getActiveTab);
  },
};
</script>
